import { TooltipProps } from '@fattureincloud/fic-design-system';

export const TOPBAR_HEIGHT = 48;
export const SIDEBAR_WIDTH = 70;
export const SIDEBAR_WIDTH_EXPANDED = 150;
export const MOBILE_BOTTOMBAR_HEIGHT = 60;
export const TRANSITION_SIDEBAR = '300ms';
export const TOOLTIP_TYPE: TooltipProps['type'] = 'light';
